import React from 'react';
import 'CSS/demand-supply/demand-supply.scss';
import 'CSS/dashboard-statistic.scss';
import 'CSS/dashboard-tickets.scss';
import 'CSS/dashboard-slips.scss';
import Grid from '@material-ui/core/Grid';
import Star from '@material-ui/icons/Star';
import FormHelperText from '@material-ui/core/FormHelperText';
import StarBorder from '@material-ui/icons/StarBorder';

class RateAnswer extends React.Component {
  renderStars = () => {
    let stars = [1, 2, 3, 4, 5];
    return stars.map((star, i) =>
      this.props.rated > i ? (
        <Star
          className="slip-star c-primary"
          key={i}
          onClick={this.props.setRate(i + 1)}
        />
      ) : (
        <StarBorder
          className="slip-star"
          key={i}
          onClick={this.props.setRate(i + 1)}
        />
      )
    );
  };
  render() {
    return (
      <Grid
        item
        // lg={4}
        // md={6}
        xs={12}
        className="u-pad-l-8 u-pad-l-8"
      >
        <Grid
          container
          className="border-bottom-light-gray-2 height-100p u-pad-bot-10 "
        >
          <Grid
            item
            // lg={4}
            // md={6}
            xs={6}
            className=""
          >
            <h2 className="t-primary-16 t-weight-b u-mrg-bot-10 u-mrg-top-10">
              Rate answer
            </h2>
          </Grid>
          <Grid
            container
            className="t-primary-14 c-gray-light"
            alignItems="center"
          >
            {this.renderStars()}
            {this.props.rated !== 0 ? (
              <div className="u-mrg-left-10">
                Rated {this.props.rated} stars
              </div>
            ) : (
              <div className="u-mrg-left-10">Not rated</div>
            )}
          </Grid>
          {this.props.error.rating && (
            <FormHelperText error>{this.props.error.rating}</FormHelperText>
          )}
        </Grid>
      </Grid>
    );
  }
}
export default RateAnswer;
